import { render } from "./ProsesPDOIOS.vue?vue&type=template&id=17694ef0"
import script from "./ProsesPDOIOS.vue?vue&type=script&lang=js"
export * from "./ProsesPDOIOS.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__